import '../../../src/styles/globals.scss';
import './C2CPage.scss';
import React, {useEffect, useState} from "react";
// @ts-ignore
import InputMask from 'react-input-mask';
/*import C2CService from '../../../services/c2c';*/
import {useForm} from "react-hook-form";
import PulPalLoader from "../PulPalLoader/PulPalLoader";
import {useSelector} from "react-redux";
import C2CService from "../../services/c2c";
import {useNavigate} from "react-router-dom";
import {t} from 'i18next'
import {useTranslation} from "react-i18next";
import { Controller } from "react-hook-form";
import ReCAPTCHA from 'react-google-recaptcha';
import { useRef } from 'react';
interface C2CPurpose {
    id: number;
    name: string;
    nameEn: string;
    requiresNote: boolean;
}
export const C2CPage = () => {
    const [loadingNotTransparent, setLoadingNotTransparent] = useState<boolean>(false);
    const {language} = useSelector((state: any) => state.languageReducer);
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY as string;
    const lang = localStorage.getItem('language') || 'ru'
    const recaptchaRef = useRef<ReCAPTCHA>(null);
    const [captchaToken, setCaptchaToken] = useState<string | null>(null);

    const [purposeList, setPurposeList] = useState<C2CPurpose[]>([]);
    const [purposeLoading, setPurposeLoading] = useState<boolean>(false);
    const [purposeError, setPurposeError] = useState<string>("");
    // Text for the limit modal when the backend refused the transfer (per-sender daily / monthly limit).
    const [limitMessage, setLimitMessage] = useState<string>("");
    /* window.scrollTo({ top: 0, behavior: 'smooth' });*/

    /* const {
         control,
         register,
         handleSubmit,
         setError,
         reset,
         formState: { errors }
     } = useForm({
         mode: "all",  shouldFocusError: false,
         defaultValues: {
             phone: '',
             toCardCustomField: '',
             c2cDate: '',
             cvv: '',
             c2cNumberT: '',
             valuta: 'AZN',
             amount: '',
         }
     });*/

    /*const [c2cOptions, setC2cOptions] = useState({
        phone: '',
        toCardCustomField: '',
        c2cDate: '',
        cvv: '',
        c2cNumberT: '',
        valuta: 'AZN',
        amount: '',
    });*/

    const {
        control,
        register,
        handleSubmit,
        setError,
        setValue,
        reset,
        formState: { errors }
    } = useForm({
        mode: "all",
        shouldFocusError: false,
        defaultValues: {
            /*  phone: "",*/

            // Göndərən kart
            c2cNumberT: "",
            c2cDate: "",
            cvv: "",
            senderName: "",
            senderPin: "",

            // Qəbul edən kart
            toCardCustomField: "",
            recipientName: "",

            valuta: "AZN",
            amount: "",

            purposeId: "",
            purposeNote: "",
        }
    });

    const [c2cOptions, setC2cOptions] = useState({
        /*phone: "",*/

        // Göndərən kart
        c2cNumberT: "",
        c2cDate: "",
        cvv: "",
        senderName: "",
        senderPin: "",

        // Qəbul edən kart
        toCardCustomField: "",
        recipientName: "",

        valuta: "AZN",
        amount: "",

        purposeId: "",
        purposeNote: "",

    });

    const selectedPurpose = purposeList.find(
        (purpose) =>
            String(purpose.id) === String(c2cOptions.purposeId)
    );

    const getIpAddress = async () => {
        const res = await fetch("https://api.ipify.org?format=json");
        const data = await res.json();
        return data.ip; // → "123.123.123.123"
    };
    const collectBrowserInfo = async () => {
        const ip = await getIpAddress();

        return {
            browserIp: ip,
            browserScreenHeight: window.screen.height.toString(),
            browserScreenWidth: window.screen.width.toString(),
            browserTZ: Intl.DateTimeFormat().resolvedOptions().timeZone,
        };
    };

    useEffect(() => {
        const raw = sessionStorage.getItem("transfer");
        const data = raw ? JSON.parse(raw) : null;

        if (data) {
            const updated = {
                /*phone: data.phone || "",*/
                amount: data.amount || "",

                c2cNumberT: "",
                c2cDate: "",
                cvv: "",
                senderName: "",
                senderPin: "",

                toCardCustomField: "",
                recipientName: "",

                purposeId: "",
                purposeNote: "",


                valuta: "AZN",
            };

            setC2cOptions(prev => ({ ...prev, ...updated }));

            reset(updated);
        } else {
            console.log("Yoxdur");
        }
    }, [reset]);

    useEffect(() => {
        let isMounted = true;

        const loadPurposeList = async () => {
            try {
                setPurposeLoading(true);
                setPurposeError("");

                const response: any =
                    await C2CService.getPurposes(language);

                const list = Array.isArray(response?.data)
                    ? response.data
                    : response?.data?.data ?? [];

                if (isMounted) {
                    setPurposeList(list);

                    const firstPurposeId =
                        list.length > 0 ? String(list[0].id) : "";

                    setC2cOptions((prev) => ({
                        ...prev,
                        purposeId: firstPurposeId,
                        purposeNote: "",
                    }));

                    setValue("purposeId", firstPurposeId, {
                        shouldValidate: true,
                    });

                    setValue("purposeNote", "");
                }
            } catch (error) {
                console.error(
                    "Purpose list alınarkən xəta:",
                    error
                );

                if (isMounted) {
                    setPurposeList([]);
                    setPurposeError(
                        String(t("c2c_purpose_load_error"))
                    );
                }
            } finally {
                if (isMounted) {
                    setPurposeLoading(false);
                }
            }
        };

        if (language) {
            loadPurposeList();
        }

        return () => {
            isMounted = false;
        };
    }, [language, setValue]);

    useEffect(() => { recaptchaRef.current?.reset();
        console.log(lang, 'lang') }, [lang]);

    /*{
      "amount": 10,
      "currency": "azn",

      "description": "test pulpal",

      "country": "az",
      "browser": {
        "browserIp": "192.168.1.1",
        "browserScreenHeight": "1920",
        "browserScreenWidth": "1080",
        "browserTZ": "4",
        "mobilePhone": {
          "cc": "+994",
          "subscriber": "553633633"
        }
      },

      "email": "baliyevfarid@gmail.com",

      "receiverCard": "4127211288561627",
      "beneficiarCard": {
        "holderName": "John",

        "cardNumber": "5490274109490026",
        "expireYear": "2027",
        "expireMonth": "12",
        "cvv": "838",

        "cvvRc": "1"
      }
    }*/

    // @ts-ignore
    const [decoded, setDecoded] = useState<string | undefined>(undefined);
    /* const onSubmit = async (data: any) => {
         if (!captchaToken) {
             // RHF error göstərmək istəyirsənsə:
             setError("toCardCustomField" as any, { type: "manual", message: t("pleaseVerifyCaptcha") as any });
             return;
         }

         setLoadingNotTransparent(true);
         try {
             let collectBrowser = await collectBrowserInfo();
             const [month, year] = c2cOptions.c2cDate.split("/");

             /!*let resData = {
                 amount: Number(c2cOptions.amount),
                 currency: c2cOptions.valuta,
                 country: language,
                 email: "",
                 description: "text@pulpal.az",
                 browser: {
                     browserIp: collectBrowser.browserIp,
                     browserScreenHeight: collectBrowser.browserScreenHeight,
                     browserScreenWidth: collectBrowser.browserScreenWidth,
                     browserTZ: '4',
                     mobilePhone: {
                         cc: "+994",
                         subscriber: c2cOptions.phone.replace(/\s/g, "")
                     }
                 },
                 receiverCard: c2cOptions.toCardCustomField.replace(/\s/g, ""),
                 beneficiarCard: {
                     holderName: "",
                     cardNumber: c2cOptions.c2cNumberT.replace(/\s/g, ""),
                     expireYear: `20${year}`,
                     expireMonth: month,
                     cvv: c2cOptions.cvv,
                     cvvRc: "1"
                 },
                 source: 3,
                 captchaToken: captchaToken,
             };*!/

             let resData = {
                 amount: Number(c2cOptions.amount),
                 currency: c2cOptions.valuta,
                 country: language,
                 recipientCard: {
                     pan: c2cOptions.toCardCustomField.replace(/\s/g, ""),
                     name: "TEST RECIPIENT",
                     birthDate: "",
                 },
                 card: {
                     cardHolder: 'TEST SENDER',
                     pan: c2cOptions.c2cNumberT.replace(/\s/g, ""),
                     expiryYear: `20${year}`,
                     expiryMonth: month,
                     cvv2: c2cOptions.cvv,
                     birthDate: "",
                     //cvvRc: "1"
                 },
                 captchaToken: captchaToken,
                 remittanceMessage: "S03 reverse direction",
             };

             let res: any = await C2CService.c2cTransfer(resData);

             if (res.data?.limitCheck === false) {
                 const modalEl = document.getElementById('limitModal');
                 // @ts-ignore
                 const modal = new window.bootstrap.Modal(modalEl);
                 modal.show();
                 return;
             }

             if (res.data?.htmlResponse) {
                 const blob = new Blob([atob(res.data.htmlResponse)], { type: "text/html" });
                 const blobUrl = URL.createObjectURL(blob);
                 setDecoded(blobUrl);
                 window.location.href = blobUrl;
                 return;
             }

             if (res.data?.finalResponse) {
                 navigate(`/receipt/${res.data?.orderId}`);
             }

         } catch (error) {
             console.error("Transfer error:", error);
         } finally {
             // ✅ uğurlu/ugursuz hər iki halda reset et
             recaptchaRef.current?.reset();
             setCaptchaToken(null);
             setLoadingNotTransparent(false);
         }
     };
 */
    const getCurrentDate = () => {
        const now = new Date();

        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0");
        const day = String(now.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    };


    const onSubmit = async () => {
        if (!captchaToken) {
            setError("toCardCustomField" as any, {
                type: "manual",
                message: t("pleaseVerifyCaptcha") as any,
            });

            return;
        }

        setLoadingNotTransparent(true);

        try {
            const [month, year] =
                c2cOptions.c2cDate.split("/");

            const resData = {
                amount: Number(c2cOptions.amount),
                currency: "AZN",
                language,

                purposeId: Number(c2cOptions.purposeId),

                purposeNote: selectedPurpose?.requiresNote
                    ? c2cOptions.purposeNote.trim()
                    : "",

                // Shown in the admin panel (UserData); the connector builds the real Millikart
                // remittance message from the purpose itself.
                remittanceMessage: selectedPurpose
                    ? (language === "en" ? selectedPurpose.nameEn : selectedPurpose.name)
                    : "C2C",
                captchaToken,

                card: {
                    pan: c2cOptions.c2cNumberT.replace(
                        /\s/g,
                        ""
                    ),
                    expiryMonth: Number(month),
                    expiryYear: Number(`20${year}`),
                    cvv2: c2cOptions.cvv,
                    cardHolder: c2cOptions.senderName.trim(),
                    // Birth dates are not collected on the form; the backend mocks them
                    // (MoneySend/VSSN placeholder) before talking to processing.
                    pin: c2cOptions.senderPin.trim().toUpperCase(),
                },

                recipientCard: {
                    pan: c2cOptions.toCardCustomField.replace(
                        /\s/g,
                        ""
                    ),
                    name: c2cOptions.recipientName.trim(),
                },
            };

            const res: any = await C2CService.c2cTransferRegister(resData);

            // Per-sender limit refused by the backend: ErrorCodes 1064 (daily) / 1065 (monthly).
            // Numbers live in payment_service.c2c_settings; the modal just tells which window is full.
            const errorCode = res?.data?.code;
            const dailyLimitHit = errorCode === 1064 || errorCode === "C2cDailyLimitExceeded";
            const monthlyLimitHit = errorCode === 1065 || errorCode === "C2cMonthlyLimitExceeded";
            if (dailyLimitHit || monthlyLimitHit) {
                setLimitMessage(String(t(monthlyLimitHit ? "c2c_limit_monthly_exceeded" : "c2c_limit_daily_exceeded")));
                const modalEl = document.getElementById("limitModal");

                // @ts-ignore
                const modal = new window.bootstrap.Modal(modalEl);
                modal.show();

                return;
            }

            // Kanal DB-dən söndürülüb (c2c_settings.web_enabled = 0): 1066, və ya iş saatlarından kənar
            // (c2c_settings.web_hours): 1067. Hər ikisi eyni "xidmət əlçatan deyil" modalını açır, saat açıqlanmır.
            const channelDisabled = errorCode === 1066 || errorCode === "C2cServiceUnavailable";
            const outsideHours = errorCode === 1067 || errorCode === "C2cOutsideWorkingHours";
            if (channelDisabled || outsideHours) {
                const modalEl = document.getElementById("unavailableModal");

                // @ts-ignore
                const modal = new window.bootstrap.Modal(modalEl);
                modal.show();

                return;
            }

            if (res?.data?.limitCheck === false) {
                setLimitMessage("");
                const modalEl = document.getElementById("limitModal");

                // @ts-ignore
                const modal = new window.bootstrap.Modal(modalEl);
                modal.show();

                return;
            }

            if (res?.data?.redirectUrl) {
                // register returns { status:'Pending', reference, redirectUrl } — the redirect
                // drives 3DS and lands back on /receipt?transaction=...&ref=...
                window.location.href = res.data.redirectUrl;

                return;
            }

            if (res?.data?.reference) {
                navigate(`/receipt?transaction=${res.data.reference}`);
            }
        } catch (error) {
            console.error("Transfer error:", error);
        } finally {
            recaptchaRef.current?.reset();
            setCaptchaToken(null);
            setLoadingNotTransparent(false);
        }
    };

    /* const onSubmit = async (data: any) => {
         setLoadingNotTransparent(true);
         let collectBrowser = await collectBrowserInfo();
         const [month, year] = c2cOptions.c2cDate.split("/");

         let resData = {
             amount: Number(c2cOptions.amount),
             currency: c2cOptions.valuta,
             country: language,
             email: "",
             description: "text@pulpal.az",
             browser: {
                 browserIp: collectBrowser.browserIp,
                 browserScreenHeight: collectBrowser.browserScreenHeight,
                 browserScreenWidth: collectBrowser.browserScreenWidth,
                 browserTZ: '4',
                 mobilePhone: {
                     cc: "+994",
                     subscriber: c2cOptions.phone.replace(/\s/g, "")
                 }
             },
             receiverCard: c2cOptions.toCardCustomField.replace(/\s/g, ""),
             beneficiarCard: {
                 holderName: "",
                 cardNumber: c2cOptions.c2cNumberT.replace(/\s/g, ""),
                 expireYear: `20${year}`,
                 expireMonth: month,
                 cvv: c2cOptions.cvv,
                 cvvRc: "1"
             }
         };

         let res: any = await C2CService.c2cTransfer(resData);

         if (res.data && res.data.htmlResponse) {
             const decodedHtml = atob(res.data.htmlResponse);

             const blob = new Blob([decodedHtml], {type: "text/html"});
             const blobUrl = URL.createObjectURL(blob);

             setDecoded(blobUrl);

             setLoadingNotTransparent(false);

             //if(blobUrl) window.location.href = blobUrl
             window.open(blobUrl, "_blank");
         } else {
             setLoadingNotTransparent(false);
         }

     };*/

    // @ts-ignore
    return (
        <div className="container c2c-page">

            <div className="mt-5 pt-5">
                <div className="fw-bold fs-3">{t("cardToCardTransfer")} </div>
                <p className="text-muted mb-4">
                    {t("enterCardDetails")}
                </p>
            </div>


            <form onSubmit={handleSubmit(onSubmit)} className="my-5 p-5 rounded-20 c2c-page__form">
                <div className="row justify-content-center">

                    <div className="col-12 col-md-5">
                        <div className="fs-4 c2c-page__section-title">{t("fromCard")}</div>
                        <hr/>
                        {/*<div className="mb-3">
                            <label className="form-label">{t("phoneNumber")}</label>
                            <Controller
                                name="phone"
                                control={control}
                                defaultValue={c2cOptions.phone}
                                rules={{
                                    required: true,
                                    minLength: {value: 12, message: "Tam 9 rəqəm daxil edin"},
                                    maxLength: {value: 12, message: "Tam 9 rəqəm daxil edin"},
                                    pattern: {
                                        value: /^(?!.*_)(\d{2} \d{3} \d{2} \d{2})$/,
                                        message: "Nömrəni tam daxil edin"
                                    }
                                }}
                                render={({field}) => (
                                    <InputMask
                                        {...field}
                                        mask="99 999 99 99"
                                        type="tel"
                                        placeholder="99 999 99 99"
                                        className={`form-control ${errors.phone ? "inputsSpecial errorInputs" : ""}`}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                            field.onChange(e);
                                            setC2cOptions(prev => ({...prev, phone: e.target.value}));
                                        }}
                                    />
                                )}
                            />

                        </div>*/}

                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label className="form-label">
                                    {t("c2c_sender_name_label")}
                                </label>

                                <Controller
                                    name="senderName"
                                    control={control}
                                    rules={{
                                        required: String(t("c2c_sender_name_required_error")),
                                        minLength: {
                                            value: 3,
                                            message: String(t("c2c_name_min_length_error")),
                                        },
                                        maxLength: {
                                            value: 100,
                                            message: String(t("c2c_name_max_length_error")),
                                        },
                                    }}
                                    render={({ field }) => (
                                        <input
                                            {...field}
                                            type="text"
                                            autoComplete="cc-name"
                                            placeholder={String(t("c2c_name_placeholder"))}
                                            className={`form-control ${
                                                errors.senderName
                                                    ? "inputsSpecial errorInputs"
                                                    : ""
                                            }`}
                                            onChange={(e) => {
                                                field.onChange(e);

                                                setC2cOptions((prev) => ({
                                                    ...prev,
                                                    senderName: e.target.value,
                                                }));
                                            }}
                                        />
                                    )}
                                />

                                {errors.senderName && (
                                    <div className="form-text text-danger">
                                        {String(errors.senderName.message)}
                                    </div>
                                )}
                            </div>
                            <div className="col-md-6 mb-3">
                                    <label className="form-label">
                                        {t("fin")}
                                    </label>

                                    <Controller
                                        name="senderPin"
                                        control={control}
                                        rules={{
                                            required: String(t("c2c_fin_required_error")),
                                            minLength: {
                                                value: 7,
                                                message: String(t("c2c_fin_length_error")),
                                            },
                                            maxLength: {
                                                value: 7,
                                                message: String(t("c2c_fin_length_error")),
                                            },
                                            pattern: {
                                                value: /^[A-Za-z0-9]{7}$/,
                                                message: String(t("c2c_fin_format_error")),
                                            },
                                        }}
                                        render={({ field }) => (
                                            <input
                                                {...field}
                                                type="text"
                                                maxLength={7}
                                                autoComplete="off"
                                                placeholder={String(t("fin"))}
                                                className={`form-control ${
                                                    errors.senderPin
                                                        ? "inputsSpecial errorInputs"
                                                        : ""
                                                }`}
                                                onChange={(e) => {
                                                    const value = e.target.value.toUpperCase();

                                                    field.onChange(value);

                                                    setC2cOptions((prev) => ({
                                                        ...prev,
                                                        senderPin: value,
                                                    }));
                                                }}
                                            />
                                        )}
                                    />

                                    {errors.senderPin && (
                                        <div className="form-text text-danger">
                                            {String(errors.senderPin.message)}
                                        </div>
                                    )}

                                </div>
                        </div>

                        <div className="p-4 rounded mb-3 c2c-page__card-box">

                            <div className="mb-3">
                                <label className="form-label">{t("cardNumber")}</label>
                                <Controller
                                    name="c2cNumberT"
                                    control={control}
                                    defaultValue={c2cOptions.c2cNumberT}
                                    rules={{
                                        required: true,
                                        pattern: {
                                            value: /^(?!.*_)(\d{4} \d{4} \d{4} \d{4})$/,
                                            message: String(t("c2c_card_number_length_error")),
                                        },
                                    }}
                                    render={({field}) => (
                                        <InputMask
                                            {...field}
                                            mask="9999 9999 9999 9999"
                                            type="text"
                                            autoComplete="cc-number"
                                            name="c2cNumberT"
                                            placeholder="•••• •••• •••• ••••"
                                            className={`form-control ${errors.c2cNumberT ? "inputsSpecial errorInputs" : ""}`}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                field.onChange(e);
                                                setC2cOptions((prev) => ({...prev, c2cNumberT: e.target.value}));
                                            }}
                                        />
                                    )}
                                />

                            </div>

                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">{t("expirationDate")}</label>
                                    <Controller
                                        name="c2cDate"
                                        control={control}
                                        defaultValue={c2cOptions.c2cDate}
                                        rules={{
                                            required: true,
                                            pattern: {
                                                value: /^(?!.*_)(0[1-9]|1[0-2])\/\d{2}$/,
                                                message: String(t("c2c_expiration_date_format_error"))
                                            }
                                        }}
                                        render={({field}) => (
                                            <InputMask
                                                {...field}
                                                mask="99/99"
                                                name="cc-exp"
                                                autoComplete="cc-exp"
                                                placeholder="MM/YY"
                                                className={`form-control ${errors.c2cDate ? "inputsSpecial errorInputs" : ""}`}
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                    field.onChange(e);
                                                    setC2cOptions(prev => ({...prev, c2cDate: e.target.value}));
                                                }}
                                            />
                                        )}
                                    />
                                </div>

                                <div className="col-md-6 mb-3">
                                    <label className="form-label">CVV</label>
                                    <Controller
                                        name="cvv"
                                        control={control}
                                        defaultValue={c2cOptions.cvv}
                                        rules={{
                                            required: String(t("c2c_cvv_required_error")),
                                            minLength: {value: 3, message: String(t("c2c_cvv_min_length_error"))},
                                            maxLength: {value: 3, message: String(t("c2c_cvv_max_length_error"))},
                                            pattern: {
                                                value: /^[0-9]{3}$/,
                                                message: String(t("c2c_cvv_format_error"))
                                            }
                                        }}
                                        render={({field}) => (
                                            <InputMask
                                                {...field}
                                                mask="999"
                                                name="cc-csc"
                                                autoComplete="cc-csc"
                                                placeholder="***"
                                                className={`form-control ${errors.cvv ? "inputsSpecial errorInputs" : ""}`}
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                    field.onChange(e);
                                                    setC2cOptions(prev => ({...prev, cvv: e.target.value}));
                                                }}
                                            />
                                        )}
                                    />

                                </div>

                            </div>
                        </div>

                        <div className="mb-3">
                            <label className="form-label fw-bold">
                                {t("c2c_purpose_label")}
                            </label>

                            <Controller
                                name="purposeId"
                                control={control}
                                rules={{
                                    required: String(t("c2c_purpose_required_error")),
                                }}
                                render={({ field }) => (
                                    <select
                                        {...field}
                                        value={c2cOptions.purposeId}
                                        disabled={purposeLoading}
                                        className={`form-control form-select ${
                                            errors.purposeId
                                                ? "inputsSpecial errorInputs"
                                                : ""
                                        }`}
                                        onChange={(e) => {
                                            const selectedPurposeId =
                                                e.target.value;

                                            field.onChange(selectedPurposeId);

                                            setC2cOptions((prev) => ({
                                                ...prev,
                                                purposeId: selectedPurposeId,

                                                // Məqsəd dəyişdikdə əvvəlki qeyd silinir
                                                purposeNote: "",
                                            }));

                                            setValue("purposeNote", "", {
                                                shouldValidate: false,
                                            });
                                        }}
                                    >
                                        <option value="">
                                            {purposeLoading
                                                ? t("c2c_purpose_loading")
                                                : t("c2c_purpose_placeholder")}
                                        </option>

                                        {purposeList.map((purpose) => (
                                            <option
                                                key={purpose.id}
                                                value={purpose.id}
                                            >
                                                {language === "en"
                                                    ? purpose.nameEn
                                                    : purpose.name}
                                            </option>
                                        ))}
                                    </select>
                                )}
                            />

                            {errors.purposeId && (
                                <div className="form-text text-danger">
                                    {String(errors.purposeId.message)}
                                </div>
                            )}

                            {purposeError && (
                                <div className="form-text text-danger">
                                    {purposeError}
                                </div>
                            )}
                        </div>

                        {selectedPurpose?.requiresNote && (
                            <div className="mb-3">
                                <label className="form-label fw-bold">
                                    {t("c2c_purpose_note_label")}
                                </label>

                                <Controller
                                    name="purposeNote"
                                    control={control}
                                    rules={{
                                        required:
                                            String(t("c2c_purpose_note_required_error")),

                                        minLength: {
                                            value: 3,
                                            message: String(t("c2c_purpose_note_min_length_error")),
                                        },

                                        maxLength: {
                                            value: 250,
                                            message: String(t("c2c_purpose_note_max_length_error")),
                                        },
                                    }}
                                    render={({ field }) => (
                                        <input
                                            {...field}
                                            type="text"
                                            maxLength={250}
                                            placeholder={String(t("c2c_purpose_note_label"))}
                                            className={`form-control ${
                                                errors.purposeNote
                                                    ? "inputsSpecial errorInputs"
                                                    : ""
                                            }`}
                                            onChange={(e) => {
                                                field.onChange(e);

                                                setC2cOptions((prev) => ({
                                                    ...prev,
                                                    purposeNote: e.target.value,
                                                }));
                                            }}
                                        />
                                    )}
                                />

                                {errors.purposeNote && (
                                    <div className="form-text text-danger">
                                        {String(errors.purposeNote.message)}
                                    </div>
                                )}
                            </div>
                        )}


                    </div>

                    <div className="col-md-2">
                        <div className="d-flex justify-content-center align-items-center h-100">
                            <div className="c2c-page__arrow">
                                ➔
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-5">

                        <div className="fs-4 c2c-page__section-title">{t("toCard")}</div>
                        <hr/>

                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label className="form-label">
                                    {t("c2c_recipient_name_label")}
                                </label>

                                <Controller
                                    name="recipientName"
                                    control={control}
                                    rules={{
                                        required: String(t("c2c_recipient_name_required_error")),
                                        minLength: {
                                            value: 3,
                                            message: String(t("c2c_name_min_length_error")),
                                        },
                                        maxLength: {
                                            value: 100,
                                            message: String(t("c2c_name_max_length_error")),
                                        },
                                    }}
                                    render={({ field }) => (
                                        <input
                                            {...field}
                                            type="text"
                                            autoComplete="off"
                                            placeholder={String(t("c2c_name_placeholder"))}
                                            className={`form-control ${
                                                errors.recipientName
                                                    ? "inputsSpecial errorInputs"
                                                    : ""
                                            }`}
                                            onChange={(e) => {
                                                field.onChange(e);

                                                setC2cOptions((prev) => ({
                                                    ...prev,
                                                    recipientName: e.target.value,
                                                }));
                                            }}
                                        />
                                    )}
                                />

                                {errors.recipientName && (
                                    <div className="form-text text-danger">
                                        {String(errors.recipientName.message)}
                                    </div>
                                )}
                            </div>

                        </div>


                        {/*<div className="mb-3">
                            <label className="form-label">{t("toCard")}</label>
                            <InputMask mask="9999 9999 9999 9999"
                                       placeholder="•••• •••• •••• ••••" value={c2cOptions.toCardCustomField}
                                       className={`form-control ${errors.toCardCustomField ? "inputsSpecial errorInputs" : ""}`}
                                       {...register("toCardCustomField", {
                                           required: true,
                                           pattern: {
                                               value: /^(?!.*_)(\d{4} \d{4} \d{4} \d{4})$/,
                                               message: "Tam 16 rəqəm daxil edin"
                                           },
                                       })}
                                       autoComplete="toCardCustomField"
                                       onChange={(e: any) => {
                                           setC2cOptions({
                                               ...c2cOptions,
                                               toCardCustomField: e.target.value,
                                           });
                                       }}/>
                        </div>*/}

                        <div className="mb-3">
                            <label className="form-label">{t("toCard")}</label>
                            <Controller
                                name="toCardCustomField"
                                control={control}
                                defaultValue={c2cOptions.toCardCustomField}
                                rules={{
                                    required: true,
                                    pattern: {
                                        value: /^(?!.*_)(\d{4} \d{4} \d{4} \d{4})$/,
                                        message: String(t("c2c_card_number_length_error")),
                                    },
                                }}
                                render={({field}) => (
                                    <InputMask
                                        {...field}
                                        autoCapitalize="off"
                                        name="no_autofill_card_2"
                                        id="manual-card-input-only"
                                        autoComplete="off"
                                        autoCorrect="off"
                                        spellCheck={false}
                                        mask="9999 9999 9999 9999"
                                        placeholder="•••• •••• •••• ••••"
                                        className={`form-control ${errors.toCardCustomField ? "inputsSpecial errorInputs" : ""}`}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                            field.onChange(e);
                                            setC2cOptions(prev => ({
                                                ...prev,
                                                toCardCustomField: e.target.value,
                                            }));
                                        }}
                                    />
                                )}
                            />
                        </div>


                        <div className="mb-3">
                            <label className="form-label fw-bold">{t("transferAmount")}</label>

                            <div className="input-group">
                                <input
                                    type="number"
                                    placeholder={String(t("enterAmount"))}
                                    min="1"
                                    max="499" value={c2cOptions.amount}
                                    step="any"
                                    className={`form-control ${errors.amount ? "inputsSpecial errorInputs" : ""}`}
                                    {...register("amount", {
                                        required: true,
                                        min: {value: 1, message: String(t("c2c_amount_range_error"))},
                                        max: {value: 499, message: String(t("c2c_amount_range_error"))},
                                    })}
                                    onChange={(e: any) => {
                                        // Hard clamp while typing: above 499 -> 499, below 1
                                        // (e.g. 0.5) -> 1. Empty stays empty so the field can
                                        // be cleared.
                                        let v = e.target.value;
                                        if (v !== "" && Number(v) > 499) {
                                            v = "499";
                                            e.target.value = v;
                                        } else if (v !== "" && !isNaN(Number(v)) && Number(v) < 1) {
                                            v = "1";
                                            e.target.value = v;
                                        }
                                        setC2cOptions({
                                            ...c2cOptions,
                                            amount: v,
                                        });
                                    }}
                                />
                                {/* C2C works in AZN only — currency is fixed, no selection. */}
                                <span className="input-group-text c2c-page__currency">AZN</span>
                            </div>

                            {errors.amount && (
                                <div className="form-text text-danger">
                                    {String(errors.amount.message ?? t("c2c_amount_range_error"))}
                                </div>
                            )}

                            <div className="form-text mt-1">{t("amountLimits")}</div>
                        </div>

                        <div className="alert alert-warning rounded-4 mt-3 center"
                             style={{backgroundColor: "#FFF8E5", color: "#4b4b4b", border: "none"}}>
                            {t("cardToCardTransfers")}
                        </div>

                        <hr/>
                        {(() => {
                            // Acquirer fee: 1%, min 1 AZN — charged to the sender on top of the amount.
                            const amountNum = Number(c2cOptions.amount) || 0;
                            const commission = amountNum > 0
                                ? Math.max(1, Math.round(amountNum * 0.01 * 100) / 100)
                                : 0;
                            const total = amountNum + commission;
                            return (
                                <div className="c2c-page__summary">
                                    <div className="c2c-page__summary-row">
                                        <span>{t("amount")}</span>
                                        <span>{amountNum.toFixed(2)} ₼</span>
                                    </div>
                                    <div className="c2c-page__summary-row">
                                        <span>{t("Commission")}</span>
                                        <span>{commission.toFixed(2)} ₼</span>
                                    </div>
                                    <div className="c2c-page__summary-row c2c-page__summary-row--total">
                                        <span>{t("c2c_receipt_total")}</span>
                                        <span>{total.toFixed(2)} ₼</span>
                                    </div>
                                </div>
                            );
                        })()}
                    </div>

                    <div className="alert alert-warning rounded-4 mt-3 center"
                         style={{backgroundColor: "#FFF8E5", color: "#4b4b4b", border: "none"}}>
                        {t("commissionNote")}
                    </div>
                    <div className="mt-3">
                        <ReCAPTCHA
                            key={`recaptcha-${lang}}`}
                            ref={recaptchaRef}
                            sitekey={SITE_KEY}
                            hl={lang}
                            onChange={(token) => setCaptchaToken(token)}
                            onExpired={() => setCaptchaToken(null)}
                        />
                        {!captchaToken && (
                            <div className="form-text text-danger mt-1">
                                {t("pleaseVerifyCaptcha")}
                            </div>
                        )}
                    </div>

                    <div className="col-12">
                        <div className="d-flex justify-content-between mt-4">
                            <button className="btn btn-outline-secondary c2c-page__back">{t("goBack")}</button>
                            <button
                                className="btn btn-info text-white c2c-page__submit"
                                type="submit"
                            >
                                {t("TRANSFER")}
                            </button>
                        </div>
                    </div>

                </div>
            </form>

            <div className="modal fade" id="limitModal" tabIndex={-1} aria-labelledby="limitModalLabel"
                 aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="limitModalLabel">{t("c2c_limit_modal_title")}</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"
                                    aria-label={String(t("c2c_limit_modal_close_button"))}></button>
                        </div>
                        <div className="modal-body">
                            {limitMessage || t("YouHaveExceededYourDailyTransactionLimit")}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal">{t("c2c_limit_modal_close_button")}</button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="unavailableModal" tabIndex={-1} aria-labelledby="unavailableModalLabel"
                 aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content c2c-unavailable">
                        <button type="button" className="btn-close c2c-unavailable__close" data-bs-dismiss="modal"
                                aria-label={String(t("c2c_unavailable_button"))}></button>
                        <div className="c2c-unavailable__icon" aria-hidden="true">
                            <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                 strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="12" cy="12" r="9"/>
                                <path d="M12 7v5l3 2"/>
                            </svg>
                        </div>
                        <h5 className="c2c-unavailable__title" id="unavailableModalLabel">{t("c2c_unavailable_title")}</h5>
                        <p className="c2c-unavailable__text">{t("c2c_unavailable_text")}</p>
                        <p className="c2c-unavailable__hint">{t("c2c_unavailable_hint")}</p>
                        <button type="button" className="button button-c2c c2c-unavailable__button" data-bs-dismiss="modal">
                            {t("c2c_unavailable_button")}
                        </button>
                    </div>
                </div>
            </div>


            {loadingNotTransparent && (
                <div
                    className={`pulpal-loader-wrapper ${loadingNotTransparent ? 'pulpal-loader-wrapper--not-transparent' : ''} `}>
                    <PulPalLoader/>
                </div>
            )}

        </div>
    )
}
